"use client";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Link from "next/link";
import { useTranslation } from "@/hooks/useLanguage";

export const FAQ = () => {
  const { t } = useTranslation();
  const FAQList = t("faq.faq_list");

  // Ensure FAQList is always an array to prevent runtime errors
  const safeFAQList = Array.isArray(FAQList) ? FAQList : [];

  return (
    <section id="faq" className="container py-24 sm:py-32">
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        {t("faq.title_1")}{" "}
        <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
          {t("faq.title_1_span")}
        </span>
      </h2>

      <Accordion type="single" collapsible className="w-full AccordionRoot">
        {safeFAQList.map(({ question, answer }, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-start">
              {question}
            </AccordionTrigger>
            <AccordionContent>{answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <h3 className="font-medium mt-4">
        {t("faq.footer_text")}{" "}
        <Link
          rel="noreferrer noopener"
          href="#"
          className="text-primary transition-all border-primary hover:border-b-2"
        >
          {t("faq.footer_link_text")}
        </Link>
      </h3>
    </section>
  );
};
